import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select_down",
  "use": "icon-select_down-usage",
  "viewBox": "0 0 1638 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1638 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-select_down\">\n  <path d=\"M121.00266657 0L4.26666657 92.16 823.46666657 1024 1642.66666657 92.16 1525.93066657 0 823.46666657 798.72z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/svg/select_down.svg
// module id = 9+5s
// module chunks = 1